import axios from 'axios'
import {IUpdatePassword} from './_model'
const API_URL = process.env.REACT_APP_API_URL

export const UPDATE_PASSWORD_URL = `${API_URL}/users/update-password`

export function updateUserPassword(updatePassword: IUpdatePassword) {
  return axios.patch<{success: boolean; message: string}>(`${UPDATE_PASSWORD_URL}`, updatePassword)
}
